import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { publicAxios } from '../api';

const initialState = {
  facilitescategory: [],
  statusfacilitescategory: 'idle',
  errorfacilitescategory: null,
};

export const fetchFacilitescategory = createAsyncThunk('facilitescategory/fetchFacilitescategory', async () => {
  const response = await publicAxios.get('/api/user/facilites/category');
  return response.data.data.facilities_categories;
});

const facilitesCategoriesSlice = createSlice({
  name: 'facilitescategory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFacilitescategory.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFacilitescategory.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.facilitescategory = action.payload;
      })
      .addCase(fetchFacilitescategory.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default facilitesCategoriesSlice.reducer;